<div class="banner {{bgColorClass}}">
  <div class="container">
    <p  class="mb-0 text" appInvertTextColor>{{message}}</p >
    <div class="buttons">
      @if (primaryActionText.length) {
        <button (click)="onPrimaryAction()" mat-button appInvertTextColor [useComputedStyles]="true">{{primaryActionText}}</button>
      }
      @if (secondaryActionText.length) {
        <button (click)="onSecondaryAction()" mat-button appInvertTextColor [useComputedStyles]="true">{{secondaryActionText}}</button>
      }
    </div>
  </div>
</div>
@if (useOverlay) {
  <div class="banner-overlay"></div>
}
